import React, { type PropsWithChildren } from 'react';
import { UserContext } from 'context/index';
import facade from 'context/UserContext/facade';

export const UserContextComponent: React.FC<{ children: PropsWithChildren['children'] }> = ({ children }: PropsWithChildren) => {
   return <UserContext.Provider value={facade.context$}>{children}</UserContext.Provider>;
};

export default UserContextComponent;
